import "./LinkShare.scss";
import cn from "classnames";
import React from "react";
import { LinkProps } from "/Models/Generated/LinkProps";
import { IconProps } from "/Components/Icons/IconProps";
import { ColorTheme } from "/Models/Models/ColorTheme";

export interface LinkWithIconProps extends LinkProps {
  icon?: React.FC<IconProps>;
  iconMobile?: React.FC<IconProps>;
}

const LinkShare = ({
  href,
  target,
  text,
  icon,
  iconMobile,
}: LinkWithIconProps) => {
  const IconComp = icon as React.FC<IconProps>;
  const IconMobileComp = (iconMobile ?? icon) as React.FC<IconProps>;

  return (
    <div className="link-share-norad">
      {href && (
        <a className={cn("link-share-norad__container")} {...{ target, href }}>
          {IconComp && (
            <>
              <div className="link-share-norad__icon link-share-norad__icon--desktop">
                <IconComp
                  thickness={"Thin"}
                  size={"20"}
                  color={ColorTheme.default}
                />
              </div>
              <div className="link-share-norad__icon link-share-norad__icon--mobile">
                <IconMobileComp
                  thickness={"Light"}
                  size={"20"}
                  color={ColorTheme.default}
                />
              </div>
            </>
          )}
          <span className="link-share-norad__text">{text}</span>
        </a>
      )}
    </div>
  );
};

export default LinkShare;
